// extracted by mini-css-extract-plugin
export default {"progress":"styles-module__progress__src-labstep-web-core-BatchRequest-Progress-_iPbxO"};